import { motion } from 'framer-motion';
import { FiCalendar } from 'react-icons/fi';
import Button from '@components/common/Button';

/**
 * ServiceCard Component
 * Props:
 * - image
 * - title
 * - description
 * - onBook
 * Features:
 * - Hover lift/shadow
 * - Opens BookingWizard modal
 */

const ServiceCard = ({ id, image, title, description, price, onBook }) => {
  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
    >
      {/* Image */}
      <div className="relative h-56 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
        />
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          {title}
        </h3>
        
        <p className="text-gray-600 mb-4 line-clamp-3">
          {description}
        </p>

        {price && (
          <p className="text-2xl font-bold text-secondary-600 mb-4">
            From £{price.toFixed(2)}
          </p>
        )}

        <Button
          text="Book Service"
          type="primary"
          onClick={() => onBook({ id, title, price })}
          className="w-full"
          icon={<FiCalendar />}
        />
      </div>
    </motion.div>
  );
};

export default ServiceCard;

